import url from 'url';

/* =====================
 * 讓使用者在輸入的停止的時候才執行某個動作
 * ===================== */
function throttle(fn, delay) {
  var timer = null;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, delay);
  };
}

function throttleEventWithRAFEvent(origEventName, newEventName, eventObj) {
  eventObj = eventObj || window;
  var running = false;
  var func = function() {
    if (running) {
      return;
    }
    running = true;
    requestAnimationFrame(function() {
      // IE部分obj不支援下方寫法，先改成這種寫法
      var event = document.createEvent('Event');
      event.initEvent(newEventName, false, true);
      eventObj.dispatchEvent(event);

      // eventObj.dispatchEvent(new CustomEvent(newEventName));
      running = false;
    });
  };
  return eventObj.addEventListener(origEventName, func);
}
throttleEventWithRAFEvent('resize', 'optimizedResize');
throttleEventWithRAFEvent('scroll', 'optimizedScroll');

/* =====================
 * 確認來源是否為行動裝置
 * ===================== */
function mobilecheck () {
  var check = false;
  (function(a) {
    if (
      // eslint-disable-next-line
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        a
      ) 
      // eslint-disable-next-line
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

function mobileAndTabletcheck() {
  var check = false;
  (function(a) {
    if (
      // eslint-disable-next-line
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      )
      // eslint-disable-next-line
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

function formatNumber(number, decimal) {
  if (window.isNaN(decimal)) {
    decimal = 0;
  }

  number = number.toFixed(decimal) + '';
  var x = number.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '.' + x[1] : '';
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    // eslint-disable-next-line
    x1 = x1.replace(rgx, '$1' + ',' + '$2');
  }
  return x1 + x2;
}

function toUTF8Array(str) {
  var utf8 = [];
  for (var i = 0; i < str.length; i++) {
    var charcode = str.charCodeAt(i);
    if (charcode < 0x80) utf8.push(charcode);
    else if (charcode < 0x800) {
      utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
    } else if (charcode < 0xd800 || charcode >= 0xe000) {
      utf8.push(
        0xe0 | (charcode >> 12),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      );
    } else {
      // surrogate pair
      i++;
      // UTF-16 encodes 0x10000-0x10FFFF by
      // subtracting 0x10000 and splitting the
      // 20 bits of 0x0-0xFFFFF into two halves
      charcode =
        0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
      utf8.push(
        0xf0 | (charcode >> 18),
        0x80 | ((charcode >> 12) & 0x3f),
        0x80 | ((charcode >> 6) & 0x3f),
        0x80 | (charcode & 0x3f)
      );
    }
  }
  return utf8;
}

function getUrlDomain(sourceurl) {
  return url.parse(sourceurl).hostname;
}

function shallowCopy(object) {
  if (object === undefined) {
    return undefined;
  }

  return JSON.parse(JSON.stringify(object));
}


var windowlocation = window.location.toString().toLowerCase();
var DOMAIN = 'localhost:8080';
var CUPOY_URL = window.location.protocol + '//' + DOMAIN + '/';
var SECURE_CUPOY_URL = 'https://' + DOMAIN + '/';

if (windowlocation.indexOf('localhost:8080') !== -1) {
  SECURE_CUPOY_URL = 'http://localhost:8080';
} else if (windowlocation.indexOf('.taocart.com') !== -1) {
  SECURE_CUPOY_URL = 'http://' + DOMAIN + '/';
} else if (windowlocation.indexOf('prerelease.') !== -1) {
  SECURE_CUPOY_URL = 'https://' + DOMAIN + '/';
}


/**
 *  web <--> mobile url 切換規則
 * 
 *  1. localhost --> localhost/mobile_index.html
 *  2. local.fabfolder.com -- > local.fabfolder.com/mobile_index.html
 *  3. bate.fabfolder.com --> m.beta.fabfolder.com
 *  4. www.cupoy.com --> m.cupoy.com
 *
 **/
var hostname = window.location.hostname;
var location = window.location.href;
var origin = window.location.origin;
if (mobilecheck()) {
  window.isMobile = true;
  // is mobile, kick to mobile page
  
  if (hostname.indexOf('localhost') === 0) {
    if (location.indexOf('/mobile_index.html') === -1) {
      if (location.indexOf('/index.html') !== -1) {
        window.location.href = location.replace(
          '/index.html',
          'mobile_index.html#'
        );
      } else {
        window.location.href = location.replace(
          origin + '/',
          origin + '/mobile_index.html#'
        );
      }
    }
  } else {
    // 不特別檢查是否為player網址才進入mobile index
    // if (hostname.indexOf('m.') == -1 && (url.indexOf('collection') > 0 || url.indexOf('feed') > 0 || url.indexOf('news') > 0) ) {
    if (hostname.indexOf('www.') === 0) {
      window.location.hostname = hostname.replace('www.', 'm.');
    } else if (hostname.indexOf('m.') === -1) {
      window.location.hostname = 'm.' + hostname;
    }
    // }
  }
} else {
  window.isMobile = false;
  // is desktop, kick to desktop page
  if (hostname.indexOf('localhost') === 0) {
    if (location.indexOf('/mobile_index.html') !== -1) {
      window.location.href = location.replace('/mobile_index.html', '/');
    }
  } else {
    if (hostname.indexOf('m.') === 0) {
      if (hostname.indexOf('local.taocart.com') > 0) {
        window.location.hostname = hostname.replace('m.', '');
      } else {
        window.location.hostname = hostname.replace('m.', 'www.');
      }
    }
  }
}

function fetchWithCookies(url, options) {
  if (options) {
    options.credentials = 'include';
  } else {
    options = {
      credentials: 'include'
    };
  }

  return fetch(url, options);
}

const DEFAULT_BUYERCRN = '0000000000';

// ------------------------------
// 產生期別字串
// ------------------------------
function getYearmonthString(date) {
  var yyyy = date.getFullYear() - 1911;
  var mm = date.getMonth() + 1;
  var nextmm = mm + 1;

  mm = (mm < 10) ? '0' + mm.toString() : mm.toString();
  nextmm = (nextmm < 10) ? '0' + nextmm.toString() : nextmm.toString();

  return yyyy.toString() + mm + nextmm;
}

// ------------------------------
// 產生之後兩期以及前三期的期別列表
// ------------------------------
function getYearmonthList() {
  var result = [];

  var date = new Date();
  var mm = date.getMonth() + 1;

  if(mm % 2 === 1) {
    date.setMonth(date.getMonth() + 4);
  } else {
    date.setMonth(date.getMonth() + 3);
  }

  for(var i = 0; i < 6; i++) {
    result.push(getYearmonthString(date));
    date.setMonth(date.getMonth() - 2);
  }

  return result;
}

// ------------------------------
// 取得目前的期別
// ------------------------------
function getNowYearmonth() {
  
  var date = new Date();
  var mm = date.getMonth();

  if(mm % 2 === 1) {
    date.setMonth(date.getMonth() + 1);
  }

  return getYearmonthString(date);
}

const NOW_YEARMONTH = getNowYearmonth();
const YEARMONTH_LIST = getYearmonthList();

const CARRIER_TYPE = {
  MEMBER: {
    label: '會員載具',
    value: "EJ1505"
  },
  CITIZEN_CERT: {
    label: '自然人憑證條碼',
    value: "CQ0001"
  },
  MOBILE: {
    label: '手機條碼',
    value: "3J0002"
  },
}

const SRCTYPE = {
  JCOLOR: 'JCOLORADMINWEB',
  SHEN: 'SHENERPSYSTEM15820097',
}

const SETTLE_TYPE = {
  SYSTEM: 1,
  OPERATOR: 2,
};

const jcolorglobal = {
  fetchWithCookies,
  DOMAIN,
  CUPOY_URL,
  SECURE_CUPOY_URL,
  shallowCopy,
  toUTF8Array,
  throttle,
  throttleEventWithRAFEvent,
  formatNumber,
  mobileAndTabletcheck,
  mobilecheck,
  getUrlDomain,
  DEFAULT_BUYERCRN,
  NOW_YEARMONTH,
  YEARMONTH_LIST,
  CARRIER_TYPE,
  SRCTYPE,
  SETTLE_TYPE,
}

export default jcolorglobal;



// WEBPACK FOOTER //
// ./src/jcolorglobal.js